import React from 'react'
import { Route, Switch } from 'react-router'
import { version } from '../package.json'
import routes from './routes'

const App = () => (
  <div data-app-version={version}>
    <Switch>
      {routes.map((params, i) => (
        <Route key={i} {...params} />
      ))}
    </Switch>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/app.js